import React, {Component} from 'react';
import ReactEcharts from 'echarts-for-react'; 
import I18n from 'lib/i18n/i18n';

import { isIphone, isMobile } from '../../helpers/ApplicationHelper';

class Chart extends Component {
    capitalize = str => (str || '') && str.charAt(0).toUpperCase() + str.slice(1);
    buildSubTitle = name => <div className="title subTitle">{I18n.getString(`itemPage::trends::${name}::subTitle`)}</div>

    render() {

        const chartName = require('./chartOptions/' + this.props.name + '.js');
        const itemTypeName = this.capitalize(this.props.itemTypeName);
        const subTitle = this.props.subTitle ? this.buildSubTitle(this.props.name) : ''

        return (
            <div className="graph" id={`graph${this.props.id}`}>
                <div className="title">
                    <div>{I18n.getString(`itemPage::trends::${this.props.name}::title`, {itemTypeName})}</div>
                    {subTitle}
                </div>
                <ReactEcharts
                    option={chartName.getOption(this.props, this.props.name === 'similarValuables' && isMobile() && isIphone())}
                />
            </div>
        )
    }
}

export default Chart;